// extracted by mini-css-extract-plugin
module.exports = {"overlayImage":"ImageWithOverlay_overlayImage__pMoRw"};